module.exports = __webpack_public_path__ + "img/icon-lalamove.78481b5b.png";